import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
// import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import "./listBuilder.css";
import axios from "axios";
import LineGraph from "./lineGraph";
import { columnsBuilders } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListBuilders = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");

  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
    const builderData = {
      page,
      limit: pageSize,
      is_deleted: false,
      filter: debouncedSearch,
      signup_from: "builder_panel",
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(viewBuilderList(builderData, showLoader));

      if (!showLoader) {
        toast.success("Bookings list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh bookings list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDetails, pagination.current, pagination.pageSize]);

  const { builders, loading } = useSelector((state) => state.builders);

  useEffect(() => {
    if (builders?.total) {
      setPagination((prevData) => ({ ...prevData, total: builders.total }));
    }
  }, [builders]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    // fetchDetails(pagination.current, pagination.pageSize);
  };

  const graphOptions = ["year", "month", "week"];
  const [graphData, setGraphData] = useState({});

  const [graphSelect, setGraphSelect] = useState({ type: "year" });

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    const selectionGetGraphDataHandler = async (event) => {
      try {
        const response = await axios.post(
          `${BASE_URL}/builder/graph`,
          graphSelect,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        if (response) {
          setGraphData(response.data.data);
        }
      } catch (error) {
        console.error("Error Loading Graph Data");
      }
    };
    selectionGetGraphDataHandler();
  }, [dispatch, graphSelect, BASE_URL]);

  return (
    <MainLayout>
      <div className="dashboard-container">
        <div className="topbar-container">
          <div className="total_builder">
            <h1 style={{ marginTop: "30px" }}>Total Builders</h1>
            <h1 style={{ fontSize: "80px", marginTop: "50px" }}>
              {builders?.total}
            </h1>
          </div>
          <div className="builder_graph">
            <div className="builder_graph_div">
              <h1>Total Builders Graph</h1>
              <select
                style={{ cursor: "pointer" }}
                name=""
                id=""
                onChange={(event) =>
                  setGraphSelect((prevData) => ({
                    ...prevData,
                    type: event.target.value,
                  }))
                }
              >
                <option disabled selected hidden value="">
                  Year
                </option>
                {Array.isArray(graphOptions) &&
                  graphOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option?.charAt(0)?.toUpperCase() + option.slice(1)}
                    </option>
                  ))}
                {/* {graphData && graphData.length > 0 && <LineGraph graphData={graphData} />} */}
              </select>
            </div>
            <LineGraph graphData={graphData}></LineGraph>
          </div>
          <div className="recently_added">
            <div className="overall_added">
              <div className="h3andbutton">
                <h3>Recently Added</h3>
              </div>
              <div className="builder_list">
                {Array.isArray(builders?.data) &&
                  builders.data.map((builder, index) => (
                    <div className="builder_item" key={index}>
                      <div className="builder_item_left">
                        <div className="builder_avatar_wrapper">
                          <img
                            className="profile_image"
                            src={
                              builder?.profile_image
                                ? builder.profile_image
                                : require("../../Global Icons/AlternateImage.png")
                            }
                            alt="Profile"
                          />
                          <span className="builder_status_dot" />
                        </div>
                        <div className="builder_info">
                          <span className="builder_name">
                            {builder?.brand_name || "No Data"}
                          </span>
                          <p className="builder_date">
                            🗓 {builder?.created_at?.slice(0, 10) || "No Data"}
                          </p>
                        </div>
                      </div>
                      <div className="brand_container" style={{ background: "transparent"}}>
                        <img
                          className="brand_logo_img"
                          style={{ height: "50px", width: "130px", borderRadius: "17px", objectFit: "cover"}}
                          src={
                            builder?.brand_logo
                              ? builder.brand_logo
                              : require("../../Global Icons/Enquire.svg")
                          }
                          alt=""
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>

        <div className="table_component_all">
          <ListTopSearch
            h3heading="Builders List"
            setState={setSearchQuery}
            onCalendarClick={() => setIsDatePopupVisible(true)}
          ></ListTopSearch>
          <div style={{ overflowX: "auto", padding: "0px 60px" }}>
            <Table
              dataSource={Array.isArray(builders?.data) ? builders.data : []}
              pagination={pagination}
              scroll={{ x: 1700, y: 500 }}
              onChange={handleTableChange}
              loading={loading}
              columns={columnsBuilders}
              rowClassName={() => "text-center"}
            ></Table>
          </div>
        </div>
        <DateRangePopup
          visible={isDatePopupVisible}
          initialStart={dateRange.start}
          initialEnd={dateRange.end}
          onCancel={() => setIsDatePopupVisible(false)}
          onOk={handleDateRangeApply}
        />
      </div>
    </MainLayout>
  );
};

export default ListBuilders;
